import styled from 'styled-components'

const Container = styled.div`
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  padding: 15px;
  min-height: 500px;
  text-align: center;
`

const ButtonsContainer = styled.div`
  width: 300px;
  margin: 60px auto 0;
  button:first-of-type {
    margin-top: 30px;
  }
`

export { Container, ButtonsContainer }
